import { AlertUnsubscribePageLoader } from './components';
import alertUnsubscribeMutation from './mutation.graphql';

const AlertUnsubscribePage = AlertUnsubscribePageLoader;

AlertUnsubscribePage.defaultProps = {};

AlertUnsubscribePage.graphQL = alertUnsubscribeMutation;

AlertUnsubscribePage.variables = ({ key }) => ({
  token: key || '',
});

export default AlertUnsubscribePage;
